export default [
  '.com',
  '.cn',
  '.net',
  // '.cc',
  '.biz',
  '.中国',
  '.公司',
  '.网络',
  // '.中文网',
  '.集团',
  '.网店',
  '.网址',
  '.手机',
  '.企业',
  '.xyz',
  '.club',
  '.fund',
  '.gold',
  '.group',
  '.ltd',
  '.tech',
  '.top',
  '.site',
  '.online',
  '.shop',
  '.购物',
  '.art',
  '.wang',
  '.company',
  '.world',
  '.store',
  '.team',
  '.center',
  '.show',
  '.live',
  '.ren',
  '.fun',
  '.city',
  '.video',
  '.chat',
  '.cool',
  '.guru',
  '.pub',
  '.run',
  '.social',
  '.today',
  '.zone',
  '.life',
  '.plus'
]


// WEBPACK FOOTER //
// ./static/assets/suffix2.js